import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Documenttitle } from './documenttitle';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DocumenttitleService {
  baseUrl: string = environment.serviceUrl;

  constructor(private httpClient: HttpClient) {
  }

  Get(): Observable<Documenttitle[]> {
    return this.httpClient.get<Documenttitle[]>(this.baseUrl + 'api/DocumenttitleApi')
  }
  Post(documenttitle: Documenttitle): Observable<any> {

    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/DocumenttitleApi/add', documenttitle, { headers: header, observe: 'response' })
  }
  Delete(documenttitle: Documenttitle) {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/DocumenttitleApi/activeordeactive', documenttitle, { headers: header, observe: 'response' })
  }
  Put(documenttitle: Documenttitle): Observable<any> {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.put(this.baseUrl + 'api/DocumenttitleApi/Update', documenttitle, { headers: header, observe: 'response' })
  }


}

  
